import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  selectPreventScrollState,
  startPreventScroll,
  stopPreventScroll,
  resetPreventScroll,
} from '../store/preventScroll';

// # hooks
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const usePreventScrollStore = () => {
  const PreventScrollState = useSelector(selectPreventScrollState);

  const dispatch = useDispatch();

  const boundStartPreventScroll = useCallback(() => dispatch(startPreventScroll()), [dispatch]);
  const boundStopPreventScroll = useCallback(() => dispatch(stopPreventScroll()), [dispatch]);
  const boundResetPreventScroll = useCallback(() => dispatch(resetPreventScroll()), [dispatch]);

  return {
    PreventScrollState,
    startPreventScroll: boundStartPreventScroll,
    stopPreventScroll: boundStopPreventScroll,
    resetPreventScroll: boundResetPreventScroll,
  };
};

export default usePreventScrollStore;
